document.documentElement.classList.remove('no-js');
document.documentElement.classList.add('js');

/* Horaires saisonniers du vendredi.
   Le serveur fixe `data-season` au rendu ; ce script le recalcule avec
   l'horloge du visiteur au fuseau de Bruxelles, pour le cas où la page
   proviendrait d'un cache antérieur au changement de saison. */
(() => {
  const root = document.documentElement;
  const zone = 'Europe/Brussels';

  const brusselsParts = () => {
    const parts = new Intl.DateTimeFormat('en-GB', {
      timeZone: zone,
      month: '2-digit',
      day: '2-digit',
      timeZoneName: 'shortOffset',
    }).formatToParts(new Date());
    const pick = (type) => parts.find((part) => part.type === type)?.value || '';
    return { monthDay: `${pick('month')}-${pick('day')}`, offset: pick('timeZoneName') };
  };

  try {
    const { monthDay, offset } = brusselsParts();
    let summer;
    if (root.dataset.seasonRule === 'custom' && root.dataset.summerStart && root.dataset.summerEnd) {
      const start = root.dataset.summerStart;
      const end = root.dataset.summerEnd;
      summer = start <= end ? monthDay >= start && monthDay < end : monthDay >= start || monthDay < end;
    } else {
      // Heure d'été belge : UTC+2 ; heure d'hiver : UTC+1.
      summer = /\+2\b/.test(offset);
    }
    root.dataset.season = summer ? 'summer' : 'winter';
  } catch (_error) {
    // Sans Intl complet, on garde la saison calculée par le serveur.
  }
})();

const pushEvent = (eventName, details = {}) => {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({ event: eventName, ...details });
};

document.addEventListener('click', (event) => {
  const trackedLink = event.target.closest('[data-track]');
  if (!trackedLink) return;

  pushEvent(trackedLink.dataset.track, {
    link_url: trackedLink.href || '',
    link_text: trackedLink.textContent.trim(),
  });
});

document.addEventListener('submit', (event) => {
  if (event.target.matches('[data-quote-form]')) {
    pushEvent('devis_submit');
  }

  if (event.target.matches('[data-product-form]')) {
    pushEvent('add_to_cart', {
      product_id: event.target.dataset.productId || '',
      product_title: event.target.dataset.productTitle || '',
    });
  }
});

document.querySelectorAll('[data-menu-toggle]').forEach((button) => {
  const target = document.getElementById(button.getAttribute('aria-controls'));
  const header = button.closest('.site-header');
  const scrim = header?.querySelector('[data-menu-scrim]');
  const label = button.querySelector('[data-menu-label]');
  const setMenuState = (isOpen, returnFocus = false) => {
    if (!target) return;
    button.setAttribute('aria-expanded', String(isOpen));
    target.hidden = !isOpen;
    if (scrim) scrim.hidden = !isOpen;
    document.body.classList.toggle('menu-open', isOpen);
    if (label) label.textContent = isOpen ? button.dataset.closeLabel : button.dataset.openLabel;
    if (returnFocus) button.focus();
  };

  button.addEventListener('click', () => {
    if (!target) return;
    const isOpen = button.getAttribute('aria-expanded') === 'true';
    setMenuState(!isOpen);
  });

  scrim?.addEventListener('click', () => setMenuState(false, true));
  target?.addEventListener('click', (event) => {
    if (event.target.closest('a')) setMenuState(false);
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && button.getAttribute('aria-expanded') === 'true') {
      setMenuState(false, true);
    }
  });

  window.addEventListener('resize', () => {
    if (window.matchMedia('(min-width: 1101px)').matches && button.getAttribute('aria-expanded') === 'true') {
      setMenuState(false);
    }
  });
});

document.querySelectorAll('form.language-switcher').forEach((form) => {
  const details = form.querySelector('[data-language-switcher]');
  const options = [...form.querySelectorAll('[data-language-option]')];

  form.querySelectorAll('[data-language-code]').forEach((link) => {
    link.addEventListener('click', (event) => {
      const input = form.querySelector('input[name="language_code"]');
      if (!input) return;

      event.preventDefault();
      if (link.getAttribute('aria-current') === 'true') {
        details?.removeAttribute('open');
        details?.querySelector('summary')?.focus();
        return;
      }
      input.value = link.dataset.languageCode;
      form.setAttribute('aria-busy', 'true');
      form.submit();
    });
  });

  details?.addEventListener('toggle', () => {
    if (!details.open) return;
    document.querySelectorAll('[data-language-switcher][open]').forEach((otherDetails) => {
      if (otherDetails !== details) otherDetails.removeAttribute('open');
    });
  });

  details?.addEventListener('keydown', (event) => {
    const currentIndex = options.indexOf(document.activeElement);
    if (event.key === 'ArrowDown') {
      event.preventDefault();
      if (!details.open) details.open = true;
      options[currentIndex < 0 ? 0 : (currentIndex + 1) % options.length]?.focus();
    } else if (event.key === 'ArrowUp') {
      event.preventDefault();
      if (!details.open) details.open = true;
      options[currentIndex < 0 ? options.length - 1 : (currentIndex - 1 + options.length) % options.length]?.focus();
    } else if (event.key === 'Home' && currentIndex >= 0) {
      event.preventDefault();
      options[0]?.focus();
    } else if (event.key === 'End' && currentIndex >= 0) {
      event.preventDefault();
      options[options.length - 1]?.focus();
    }
  });
});

document.addEventListener('click', (event) => {
  document.querySelectorAll('[data-language-switcher][open]').forEach((details) => {
    if (!details.contains(event.target)) details.removeAttribute('open');
  });
});

document.addEventListener('keydown', (event) => {
  if (event.key !== 'Escape') return;
  document.querySelectorAll('[data-language-switcher][open]').forEach((details) => {
    details.removeAttribute('open');
    details.querySelector('summary')?.focus();
  });
});

document.querySelectorAll('[data-variant-select]').forEach((select) => {
  const form = select.closest('form');
  const price = form?.closest('[data-product-root]')?.querySelector('[data-live-price]');
  const button = form?.querySelector('[type="submit"]');

  select.addEventListener('change', () => {
    const option = select.selectedOptions[0];
    if (!option) return;

    if (price && option.dataset.price) price.textContent = option.dataset.price;
    if (button) {
      const available = option.dataset.available === 'true';
      button.disabled = !available;
      button.textContent = available ? button.dataset.availableLabel : button.dataset.soldOutLabel;
    }

    const url = new URL(window.location.href);
    url.searchParams.set('variant', option.value);
    window.history.replaceState({}, '', url);
  });
});

document.querySelectorAll('[data-collection-sort]').forEach((select) => {
  select.addEventListener('change', () => select.form?.submit());
});

document.querySelectorAll('[data-product-options]').forEach((picker) => {
  const root = picker.closest('[data-product-root]');
  const select = root?.querySelector('[data-variant-select]');
  const variantsNode = root?.querySelector('[data-product-variants]');
  if (!select || !variantsNode) return;

  let variants = [];
  try {
    variants = JSON.parse(variantsNode.textContent);
  } catch (_error) {
    return;
  }

  const groups = [...picker.querySelectorAll('[data-option-position]')];
  const readSelectedOptions = () => groups.map(
    (group) => group.querySelector('[data-option-value]:checked')?.value || '',
  );
  const updateSelectedLabels = (selected) => {
    groups.forEach((group, index) => {
      const label = group.querySelector('[data-selected-option]');
      if (label) label.textContent = selected[index];
    });
  };
  const applyVariant = (variant) => {
    variant.options.forEach((value, index) => {
      const matchingInput = [...groups[index].querySelectorAll('[data-option-value]')]
        .find((input) => input.value === value);
      if (matchingInput) matchingInput.checked = true;
    });
    updateSelectedLabels(variant.options);
    select.value = String(variant.id);
    select.dispatchEvent(new Event('change', { bubbles: true }));

    const mainImage = root.querySelector('.product-gallery img');
    const variantImage = variant.featured_image;
    if (mainImage && variantImage?.src) {
      mainImage.src = variantImage.src;
      mainImage.removeAttribute('srcset');
      if (variantImage.alt) mainImage.alt = variantImage.alt;
    }
  };
  const updateVariant = (changedInput) => {
    const selected = readSelectedOptions();
    let variant = variants.find(
      (candidate) => candidate.options.every((value, index) => value === selected[index]),
    );

    if (!variant && changedInput) {
      const changedGroup = changedInput.closest('[data-option-position]');
      const changedIndex = groups.indexOf(changedGroup);
      const score = (candidate) => candidate.options.reduce(
        (total, value, index) => total + (index !== changedIndex && value === selected[index] ? 1 : 0),
        0,
      );
      variant = variants
        .filter((candidate) => candidate.options[changedIndex] === changedInput.value)
        .sort((first, second) => (
          Number(Boolean(second.available)) - Number(Boolean(first.available)) || score(second) - score(first)
        ))[0];
    }

    if (!variant) return;
    applyVariant(variant);
  };

  picker.querySelectorAll('[data-option-value]').forEach((input) => {
    input.addEventListener('change', () => updateVariant(input));
  });
  updateVariant();
});

/* Pré-remplissage et confirmation du formulaire de devis.
   Objectif : réduire au minimum le nombre de champs à saisir lorsque
   l'appareil et la panne sont déjà connus par la page d'origine. */
(() => {
  const params = new URLSearchParams(window.location.search);
  const prefill = {
    device: params.get('appareil') || params.get('toestel') || params.get('device') || '',
    issue: params.get('panne') || params.get('probleem') || params.get('issue') || '',
  };

  document.querySelectorAll('[data-quote-shell]').forEach((shell) => {
    Object.entries(prefill).forEach(([field, value]) => {
      if (!value) return;
      const input = shell.querySelector(`[data-quote-field="${field}"]`);
      if (input && !input.value.trim()) input.value = value;
    });
  });

  const success = document.querySelector('[data-quote-success]');
  if (success) {
    success.scrollIntoView({ block: 'center', behavior: 'smooth' });
    success.focus({ preventScroll: true });
  }

  const errors = document.querySelector('.quote-form .form-status--error');
  if (errors) {
    errors.scrollIntoView({ block: 'center', behavior: 'smooth' });
    errors.focus({ preventScroll: true });
  }
})();

/* Choix du support sur la rubrique Récupération de données.
   Le lien fonctionne sans JavaScript grâce au paramètre `panne`. Avec
   JavaScript, on évite le rechargement : le champ est rempli sur place.
   Pour un disque dur ou un SSD nu, « Appareil et modèle » devient facultatif. */
(() => {
  const tiles = document.querySelectorAll('[data-support-pick]');
  if (!tiles.length) return;
  const noDeviceKeys = ['hdd', 'ssd'];

  const setDeviceOptional = (optional) => {
    const device = document.querySelector('[data-quote-field="device"]');
    if (!device) return;
    device.required = !optional;
    const mark = device.closest('.field')?.querySelector('.field__required');
    if (mark) mark.hidden = optional;
  };

  const pick = (tile) => {
    tiles.forEach((other) => other.classList.toggle('support-tile--picked', other === tile));
    setDeviceOptional(noDeviceKeys.includes(tile.dataset.supportKey));
  };

  tiles.forEach((tile) => {
    tile.addEventListener('click', (event) => {
      const field = document.querySelector('[data-quote-field="issue"]');
      const panel = document.getElementById('devis');
      if (!field || !panel) return;

      event.preventDefault();
      field.value = tile.dataset.supportPick;
      pick(tile);
      panel.scrollIntoView({ behavior: 'smooth', block: 'start' });
      window.setTimeout(() => field.focus({ preventScroll: true }), 400);
    });
  });

  // Au chargement (lien ?panne=…), refléter le support déjà choisi.
  const issue = document.querySelector('[data-quote-field="issue"]');
  if (issue && issue.value.trim()) {
    const match = [...tiles].find((tile) => tile.dataset.supportPick === issue.value.trim());
    if (match) pick(match);
  }
})();

